export const APIKey = 'api_key=3af561a12389e6d632bf79207cb88b6c';
export const APIPath = 'https://api.themoviedb.org/3/';
